import React from 'react';
import PropTypes from 'prop-types';

import { Form, Field, withFormik } from 'formik';
import * as yup from 'yup';
import classnames from 'classnames';
import axios from 'axios';

import Notifications, { useNotification } from '../modals/Notifications';

const SubscribeForm = props => {
  const isMobile = props.isMobile || false;

  const isWhiteBackground = props.isWhiteBackground || false;

  return (
    <div>
      <p className={classnames('tutorium-text mb-5px', { 'landing-text-sm': isMobile })}>Subscribe to our newsletter</p>
      <div className="field is-horizontal">
        <Form noValidate className="is-flex">
          <Field name="email">
            {({
              field, // { name, value, onChange, onBlur }
              form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
            }) => {
              const hasError = errors[field.name] && touched[field.name];

              const fieldClassName = classnames('form-control form-control-sm', {
                'is-invalid': hasError,
                'form-control-xs': isMobile,
              });
              return (
                <div className="field-body">
                  <div className="field">
                    <p className="control">
                      <input
                        className={fieldClassName}
                        type="email"
                        placeholder="Email"
                        {...field}
                        disabled={props.isSubmitting}
                        style={{ border: isWhiteBackground ? '1px solid rgba(19, 25, 37, 0.3)' : 'none' }}
                      />
                    </p>
                  </div>
                </div>
              );
            }}
          </Field>
          <button
            className={classnames('gradient-button gradient-button-inline', { 'gradient-button-xs': isMobile })}
            type="submit"
            disabled={props.isSubmitting}
          >
            Subscribe
          </button>
        </Form>
      </div>
    </div>
  );
};

SubscribeForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  isWhiteBackground: PropTypes.bool,
};

const initialValues = { email: '' };

const mapPropsToValues = () => initialValues;

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email()
    .required(),
});

const handleSubmit = (values, bag) => {
  bag.setSubmitting(true);

  axios
    .post('/api/v1/messages/subscribe', values)
    .then(() => {
      bag.setSubmitting(false);
      bag.props.showSuccessNotification();
      bag.resetForm(initialValues);
    })
    .catch(() => {
      bag.setSubmitting(false);
      bag.props.showErrorNotification();
    });
};

const SubscribeFormContainer = withFormik({ mapPropsToValues, validationSchema, handleSubmit })(SubscribeForm);

const SubscribeFormWithNotifications = props => {
  const successNotificationState = useNotification();
  const errorNotificationState = useNotification();

  return (
    <>
      <SubscribeFormContainer
        {...props}
        showSuccessNotification={successNotificationState.open}
        showErrorNotification={errorNotificationState.open}
      />
      <Notifications.Subscribed state={successNotificationState} />
      <Notifications.Error state={errorNotificationState} />
    </>
  );
};

export default SubscribeFormWithNotifications;
